module.exports = __webpack_public_path__ + "static/media/profile-picture-410w.3143b638.jpg";